<template>
  <li>
    <h4 :title="trackingGroup.name">
      <span>{{ trackingGroup.abbreviation || trackingGroup.name }}</span>
    </h4>
    <span v-for="measurementType in trackingGroup.MeasurementTypes" class="values">
      <span class="measurement-value">{{ measurementType.Measurement.value | number-format(2) }}</span><span class="measurement-unit">{{ measurementType.expressed_in_unit }}</span>
    </span>
  </li>
</template>

<script>
export default {
  name: 'tracked-measurements-label-group-abstract',
  props: {
    trackingGroup: {
      type: Object, // String, Number, Boolean, Function, Object, Array
      required: true,
      default: null,
    },
  },
  data() {
    return {

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/tracked-measurements-label-groups/label-group-abstract.vue